import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { SearchBar, Page } from 'components';
import Results from './components/Results';
import BulkCommandModal from './components/BulkCommandModal';

import Api from 'services/Api';
import ApiGServer from 'services/ApiGServer';
import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import { loadState, saveState } from 'utils/persistState';
import { useAppTheme } from '../../contexts/ThemeContext';

const STORAGE_KEY = 'filters:suporte';
const REFRESH_INTERVAL_MS = 30000;
const BULK_COMMAND_EMAILS = [
  'alan.aliske@motomco.com.br',
  'vilmar.ferreira@motomco.com.br',
];

const Suporte = () => {
  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.support?.read !== true) {
    window.location.replace('/home');
  }

  const [filterEquipaments, setFilterEquipaments] = useState([]);
  const [allEquipaments, setAllEquipaments] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [loading, setLoading] = useState(true);
  const [showBulkCommandModal, setShowBulkCommandModal] = useState(false);
  const searchDataRef = useRef(searchData);

  const currentTheme = useAppTheme();

  const permission = user?.permission?.support;
  const canBulkCommand = BULK_COMMAND_EMAILS.includes(user?.email);

  useEffect(() => {
    searchDataRef.current = searchData;
  }, [searchData]);

  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  const handleDetailEquipaments = async (equipments) => {
    try {
      const { data } = await ApiGServer.post(`/equipment/filter`, { filter: equipments });
      setFilterEquipaments(data);
      setAllEquipaments(data);
    } catch (error) {
      console.error('Erro ao buscar detalhes dos equipamentos:', error);
      setFilterEquipaments([]);
      setAllEquipaments([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const { data } = await Api.get('/connection/connected');
      const filteredData = (data || [])
        .filter((item) => item.includes('SIMT') || item.includes('BIMT'))
        .sort((a, b) => a.localeCompare(b));

      if (filteredData.length === 0) {
        setFilterEquipaments([]);
        setAllEquipaments([]);
        setLoading(false);
        return;
      }

      await handleDetailEquipaments(filteredData);
    } catch (error) {
      console.error('Erro ao buscar os dados:', error);
      setFilterEquipaments([]);
      setAllEquipaments([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    const interval = setInterval(() => {
      // Pausa o refresh automático enquanto houver busca ativa
      if (searchDataRef.current === '') {
        fetchData();
      }
    }, REFRESH_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  const handleSearch = () => {
    const term = searchData.trim().toLowerCase();
    if (!term) {
      setAllEquipaments(filterEquipaments);
      return;
    }

    setAllEquipaments(
      filterEquipaments.filter((company) =>
        company?.serialnumber?.toLowerCase().includes(term) ||
        company?.nameEquipament?.toLowerCase().includes(term) ||
        company?.company?.name?.toLowerCase().includes(term) ||
        company?.versaosw?.toLowerCase().includes(term)
      )
    );
  };

  useEffect(() => {
    handleSearch();
  }, [filterEquipaments, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value);
  };

  return (
    <Page className="p-3" title="Suporte">
      <Header page={"Suporte"} />

      {loading && <Reload />}

      <SearchBar
        onSearch={handleSearch}
        onSearchData={handleSearchData}
        searchData={searchData}
      />

      {canBulkCommand && (
        <div className="d-flex justify-content-end mb-2">
          <Button
            size="sm"
            onClick={() => setShowBulkCommandModal(true)}
            disabled={loading || !allEquipaments?.length}
            style={{
              backgroundColor: 'var(--brand-light-green, #8fad15)',
              color: '#fff',
              border: 'none',
            }}
          >
            Comando em massa
          </Button>
        </div>
      )}

      <BulkCommandModal
        show={showBulkCommandModal}
        onHide={() => setShowBulkCommandModal(false)}
        equipments={allEquipaments}
        currentTheme={currentTheme}
      />

      <Results
        data={allEquipaments}
        permission={permission}
        currentTheme={currentTheme}
      />
    </Page>
  );
};

export default Suporte;
